/**
 * Shared constants for schema validation limits
 * These constants ensure consistency across different schemas and components
 */

export const SCHEMA_LIMITS = {
  // Homework limits
  HOMEWORK_TITLE_MAX_LENGTH: 100,
  HOMEWORK_DESCRIPTION_MAX_LENGTH: 500,
  /** Max length for an implementation-intention trigger ("after {routine} → {action}"). */
  TRIGGER_MAX_LENGTH: 280,
  /** Safety ceiling for encrypted blob columns to block storage-amplification attacks. */
  ENCRYPTED_BLOB_MAX_LENGTH: 65536,

  // Session limits
  SESSION_TITLE_MAX_LENGTH: 100,

  /** A first or last name the coach types for a new client. */
  CLIENT_NAME_MAX_LENGTH: 100,

  // Resource limits
  RESOURCE_TITLE_MAX_LENGTH: 100,

  // Session notes limits
  SESSION_NOTES_DESCRIPTION_MAX_LENGTH: 1000,

  // File upload limits
  FILE_MAX_SIZE_MB: 50,
  AVATAR_MAX_SIZE_MB: 5,
} as const;

// File upload constants
export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
] as const;

export const BYTES_PER_MB = 1024 * 1024;

export const FILE_MAX_SIZE_BYTES =
  SCHEMA_LIMITS.FILE_MAX_SIZE_MB * BYTES_PER_MB;
export const AVATAR_MAX_SIZE_BYTES =
  SCHEMA_LIMITS.AVATAR_MAX_SIZE_MB * BYTES_PER_MB;

export const ALLOWED_DURATIONS = [30, 45, 60, 90, 120, 180] as const;

export const ALLOWED_STEP_VALUES = [15, 30, 45, 60, 120, 180] as const;

export const isAllowedDuration = (
  value: number,
): value is (typeof ALLOWED_DURATIONS)[number] => {
  return (ALLOWED_DURATIONS as readonly number[]).includes(value);
};

export const isAllowedStepValue = (
  value: number,
): value is (typeof ALLOWED_STEP_VALUES)[number] => {
  return (ALLOWED_STEP_VALUES as readonly number[]).includes(value);
};

export const createMaxLengthMessage = (
  fieldName: string,
  maxLength: number,
): string => {
  return `${fieldName} must be ${maxLength} characters or less`;
};
